import React, { Component } from 'react';
import DotLoader from '../../../Loader/DotLoader.component';
import {
    fetchCrifReportHtmlNew,
    getBureauCheckDataByUserId
} from '../../../../containers/Admin/CreditModule/CreditNewNew/ActionCreator';
import SavePopup from '../../../Popup/Popup.component';
import BankStatementUpload from './BankStatementUpload';

export default class AnalysisPopupMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'crif', // 'crif' | 'bureauCheck' | 'uploadBankStatement'
            crifHtml: '',
            bureauCheckData: null,
            loadingCrif: false,
            loadingBureau: false,
            showPopup: false,
            popupStatus: ''
        };
    }

    componentDidMount() {
        this.fetchCrifData(false);
        this.fetchBureauCheckData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.fetchCrifData(false);
            this.fetchBureauCheckData();
        }
    }

    fetchCrifData = (regenerate) => {
        const { userId, admin } = this.props;
        if (!userId) return;

        const empId = admin?.emailId || 'superuser';
        const regenerateValue = regenerate ? 1 : 0;

        this.setState({ loadingCrif: true });
        fetchCrifReportHtmlNew(userId, regenerateValue, empId, (callback) => {
            if (callback) {
                this.setState({ crifHtml: callback, loadingCrif: false });
            } else {
                console.error('Error fetching CRIF data');
                this.setState({ loadingCrif: false });
            }
        });
    };

    fetchBureauCheckData = () => {
        const { userId } = this.props;
        if (!userId) return;

        this.setState({ loadingBureau: true });
        getBureauCheckDataByUserId(userId, (res) => {
            this.setState({ bureauCheckData: res || null, loadingBureau: false });
        });
    };

    renderBureauCheckTab = (bureauData, loadingBureau) => {
        if (loadingBureau) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                    <DotLoader />
                </div>
            );
        }

        if (!bureauData) {
            return (
                <div style={{ textAlign: 'center', color: '#64748b', padding: '40px' }}>
                    <i className="fa fa-info-circle" style={{ fontSize: '24px', marginBottom: '10px', display: 'block' }} />
                    No Bureau Check data found.
                </div>
            );
        }

        const { decision, reason, reasons, scoringMetrics, bureauSource, status } = bureauData;
        const isApprove = decision && decision.toLowerCase().includes('approve');
        const isReject = decision && decision.toLowerCase().includes('reject');

        const cardStyle = {
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        };

        const cardLabelStyle = {
            fontSize: '12px',
            fontWeight: '700',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        };

        const cardValueStyle = {
            fontSize: '22px',
            fontWeight: '800',
            color: '#0f172a',
            letterSpacing: '-0.5px'
        };

        const statusBadge = (stat) => {
            const isPassed = stat === 'PASSED';
            return (
                <span style={{
                    padding: '4px 10px',
                    borderRadius: '999px',
                    fontSize: '12px',
                    fontWeight: '700',
                    background: isPassed ? '#dcfce7' : '#fee2e2',
                    color: isPassed ? '#15803d' : '#b91c1c',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px'
                }}>
                    <i className={`fa ${isPassed ? 'fa-check-circle' : 'fa-times-circle'}`} />
                    {stat || '-'}
                </span>
            );
        };

        const tableStyle = {
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            overflow: 'hidden'
        };

        const thStyle = {
            background: '#f8fafc',
            padding: '12px 16px',
            fontSize: '11px',
            fontWeight: '700',
            textTransform: 'uppercase',
            color: '#64748b',
            borderBottom: '1px solid #e2e8f0',
            textAlign: 'left',
            whiteSpace: 'nowrap'
        };

        const tdStyle = {
            padding: '12px 16px',
            fontSize: '13px',
            color: '#334155',
            borderBottom: '1px solid #e2e8f0',
            textAlign: 'left'
        };

        const metricRows = [
            {
                name: 'DPD Check (Last 3 Months)',
                metric: scoringMetrics?.dpdCheck,
                details: scoringMetrics?.dpdCheck ? `Max Observed: ${scoringMetrics.dpdCheck.maxObservedDpdLast3Months ?? '-'} | Allowed: ${scoringMetrics.dpdCheck.allowedMaxDpd ?? '-'}` : null
            },
            {
                name: 'Overdue Check',
                metric: scoringMetrics?.overdueCheck,
                details: scoringMetrics?.overdueCheck ? `Total Overdue: ₹${scoringMetrics.overdueCheck.totalOverdueAmount ?? 0} | Allowed: ₹${scoringMetrics.overdueCheck.allowedOverdueAmount ?? 0}` : null
            },
            {
                name: 'Written-Off Check',
                metric: scoringMetrics?.writtenOffCheck,
                details: scoringMetrics?.writtenOffCheck ? `Has Write-off: ${scoringMetrics.writtenOffCheck.hasWriteOff ? 'Yes' : 'No'}` : null
            },
            {
                name: 'Suit Filed Check',
                metric: scoringMetrics?.suitFiledCheck,
                details: scoringMetrics?.suitFiledCheck ? `Suit Filed: ${scoringMetrics.suitFiledCheck.hasSuitFiled ? 'Yes' : 'No'}` : null
            }
        ];

        return (
            <div>
                {/* Header Actions: Refresh Bureau Check */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                    <button
                        onClick={this.fetchBureauCheckData}
                        style={{
                            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                            border: 'none',
                            color: '#ffffff',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            fontWeight: '700',
                            fontSize: '13px',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            boxShadow: '0 2px 8px rgba(59,130,246,0.2)'
                        }}
                    >
                        <i className="fa fa-refresh" /> Refresh
                    </button>
                </div>

                {/* Top Summary Cards: Decision & Bureau Source */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
                    <div style={cardStyle}>
                        <span style={cardLabelStyle}>Decision</span>
                        <span style={{
                            ...cardValueStyle,
                            color: isApprove ? '#059669' : isReject ? '#dc2626' : '#2563eb'
                        }}>
                            {decision || status || '-'}
                        </span>
                    </div>
                    <div style={cardStyle}>
                        <span style={cardLabelStyle}>Bureau Source</span>
                        <span style={cardValueStyle}>{bureauSource || '-'}</span>
                    </div>
                </div>

                {/* Primary Reasons Card (Next Line, Full Width with List) */}
                {(() => {
                    const reasonList = (reasons && reasons.length > 0)
                        ? reasons
                        : (reason ? reason.split(';').map(s => s.trim()).filter(Boolean) : []);

                    if (reasonList.length === 0 && !reason) return null;

                    return (
                        <div style={{
                            background: isApprove ? '#f0fdf4' : isReject ? '#fef2f2' : '#f8fafc',
                            border: `1px solid ${isApprove ? '#bbf7d0' : isReject ? '#fecaca' : '#e2e8f0'}`,
                            borderRadius: '12px',
                            padding: '16px 20px',
                            marginBottom: '24px'
                        }}>
                            <span style={{
                                ...cardLabelStyle,
                                display: 'block',
                                marginBottom: '10px',
                                color: isApprove ? '#166534' : isReject ? '#991b1b' : '#64748b'
                            }}>
                                Primary Reasons
                            </span>
                            <ul style={{
                                margin: 0,
                                paddingLeft: '20px',
                                color: isApprove ? '#15803d' : isReject ? '#b91c1c' : '#334155',
                                fontSize: '13px',
                                lineHeight: '1.7',
                                fontWeight: '600'
                            }}>
                                {reasonList.map((item, idx) => (
                                    <li key={idx} style={{ marginBottom: idx === reasonList.length - 1 ? 0 : '4px' }}>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })()}

                {/* Scoring Metrics Table */}
                <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                    Policy Checks & Scoring Metrics
                </h4>
                <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>Metric / Rule</th>
                                <th style={thStyle}>Status</th>
                                <th style={thStyle}>Details</th>
                                <th style={thStyle}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {metricRows.map((row, idx) => (
                                <tr key={idx}>
                                    <td style={{ ...tdStyle, fontWeight: '700' }}>{row.name}</td>
                                    <td style={tdStyle}>{statusBadge(row.metric?.status)}</td>
                                    <td style={{ ...tdStyle, color: '#64748b', fontSize: '12px' }}>{row.details || '-'}</td>
                                    <td style={{ ...tdStyle, color: '#334155', fontWeight: '500' }}>{row.metric?.remarks || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Account Remarks List if present */}
                {scoringMetrics?.suitFiledCheck?.accountRemarksList && scoringMetrics.suitFiledCheck.accountRemarksList.length > 0 && (
                    <div>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                            Account Remarks Details ({scoringMetrics.suitFiledCheck.accountRemarksList.length})
                        </h4>
                        <div style={{ overflowX: 'auto', maxHeight: '250px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                            <table style={tableStyle}>
                                <thead>
                                    <tr>
                                        <th style={thStyle}>#</th>
                                        <th style={thStyle}>Account Type</th>
                                        <th style={thStyle}>Account Number</th>
                                        <th style={thStyle}>Suit Filed Status</th>
                                        <th style={thStyle}>Account Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {scoringMetrics.suitFiledCheck.accountRemarksList.map((acc, idx) => (
                                        <tr key={idx}>
                                            <td style={{ ...tdStyle, color: '#94a3b8', fontSize: '11px' }}>{idx + 1}</td>
                                            <td style={{ ...tdStyle, fontWeight: '600' }}>{acc.accountType || '-'}</td>
                                            <td style={tdStyle}>{acc.accountNumber || '-'}</td>
                                            <td style={tdStyle}>{acc.suitFiledStatus || '-'}</td>
                                            <td style={{ ...tdStyle, color: '#64748b' }}>{acc.accountRemarks || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { handleAnalysis, admin, userId } = this.props;
        const {
            activeTab,
            crifHtml,
            bureauCheckData,
            loadingCrif,
            loadingBureau,
            showPopup,
            popupStatus
        } = this.state;

        // Styles
        const overlayStyle = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(15, 23, 42, 0.4)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
        };

        const modalStyle = {
            background: '#ffffff',
            width: '90%',
            maxWidth: '1200px',
            height: '85vh',
            borderRadius: '16px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            border: '1px solid #e2e8f0',
            fontFamily: 'Inter, system-ui, sans-serif'
        };

        const headerStyle = {
            padding: '18px 24px',
            borderBottom: '1px solid #f1f5f9',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#ffffff'
        };

        const closeButtonStyle = {
            background: '#f1f5f9',
            border: 'none',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            color: '#64748b',
            transition: 'all 0.2s ease',
            outline: 'none'
        };

        const tabListStyle = {
            display: 'flex',
            gap: '8px',
            padding: '0 24px',
            borderBottom: '1px solid #f1f5f9',
            background: '#f8fafc'
        };

        const tabStyle = (isActive) => ({
            padding: '14px 24px',
            border: 'none',
            background: 'none',
            fontSize: '14px',
            fontWeight: '700',
            cursor: 'pointer',
            position: 'relative',
            color: isActive ? '#2563eb' : '#64748b',
            transition: 'all 0.2s ease',
            outline: 'none'
        });

        const activeLineStyle = {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '3px',
            background: '#2563eb',
            borderRadius: '3px 3px 0 0'
        };

        const bodyStyle = {
            padding: '24px',
            flex: 1,
            overflowY: 'auto',
            background: '#ffffff'
        };

        const buttonStyle = (colorType) => ({
            background: colorType === 'success' ? 'linear-gradient(135deg, #059669, #047857)' : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            border: 'none',
            color: '#ffffff',
            padding: '10px 20px',
            borderRadius: '8px',
            fontWeight: '700',
            fontSize: '13px',
            boxShadow: colorType === 'success' ? '0 2px 8px rgba(5,150,105,0.2)' : '0 2px 8px rgba(59,130,246,0.2)',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            outline: 'none',
            transition: 'all 0.2s ease'
        });

        return (
            <div style={overlayStyle}>
                <div style={modalStyle}>
                    {/* Header */}
                    <div style={headerStyle}>
                        <h3 style={{ margin: 0, fontWeight: 800, color: '#0f172a', fontSize: '18px' }}>
                            Application Analysis
                        </h3>
                        <button
                            style={closeButtonStyle}
                            onClick={() => handleAnalysis(false, '')}
                            onMouseEnter={(e) => (e.currentTarget.style.background = '#e2e8f0')}
                            onMouseLeave={(e) => (e.currentTarget.style.background = '#f1f5f9')}
                        >
                            <i className="fa fa-times" />
                        </button>
                    </div>

                    {/* Tabs */}
                    <div style={tabListStyle}>
                        <button
                            style={tabStyle(activeTab === 'crif')}
                            onClick={() => this.setState({ activeTab: 'crif' })}
                        >
                            CRIF Report
                            {activeTab === 'crif' && <div style={activeLineStyle} />}
                        </button>
                        <button
                            style={tabStyle(activeTab === 'bureauCheck')}
                            onClick={() => this.setState({ activeTab: 'bureauCheck' })}
                        >
                            Bureau Check
                            {activeTab === 'bureauCheck' && <div style={activeLineStyle} />}
                        </button>
                        <button
                            style={tabStyle(activeTab === 'uploadBankStatement')}
                            onClick={() => this.setState({ activeTab: 'uploadBankStatement' })}
                        >
                            Bank Statement
                            {activeTab === 'uploadBankStatement' && <div style={activeLineStyle} />}
                        </button>
                    </div>

                    {/* Body */}
                    <div style={bodyStyle}>
                        {activeTab === 'crif' && (
                            <div>
                                {/* Action Buttons */}
                                <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
                                    <button
                                        style={buttonStyle('success')}
                                        onClick={() => this.fetchCrifData(true)}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'none')}
                                    >
                                        <i className="fa fa-refresh" /> Regenerate CRIF
                                    </button>
                                </div>

                                {/* Report Viewer */}
                                {loadingCrif ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                        <DotLoader />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '12px',
                                            padding: '24px',
                                            background: '#fafafa',
                                            overflowX: 'auto',
                                            maxHeight: '450px',
                                            overflowY: 'auto'
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                crifHtml ||
                                                "<p style='text-align: center; color: #64748b; padding: 20px;'>No CRIF report found.</p>"
                                        }}
                                    />
                                )}
                            </div>
                        )}

                        {activeTab === 'bureauCheck' && (
                            this.renderBureauCheckTab(bureauCheckData, loadingBureau)
                        )}

                        {activeTab === 'uploadBankStatement' && (
                            <BankStatementUpload admin={admin} allDetail={{userId:userId}} />
                        )}
                    </div>
                </div>

                {showPopup && (
                    <SavePopup
                        popupStatus={popupStatus}
                        closePopup={() => this.setState({ showPopup: false })}
                    />
                )}
            </div>
        );
    }
}
